import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Home from './routes/Home.jsx';
import Etica from './routes/Etica.jsx';
import About from './routes/About.jsx';
import Fornecedor from './routes/Fornecedor';
import Denuncia from './routes/Denuncia';
import Servicos from './routes/Servicos';
import Contact from './routes/Contact';
import TrabalheConosco from './routes/TrabalheConosco';
import Login from './routes/components/forms/LoginForm';
import Register from './routes/components/forms/RegisterForm';
import Transparencia from './routes/Transparencia.jsx';
import AtivarConta from './routes/AtivarConta.jsx';
import RecuperarSenha from './routes/RecuperarSenha.jsx';
import TrocarSenha from './routes/TrocarSenha.jsx';
import NotFound from './routes/NotFound.jsx';

const router = createBrowserRouter([
  { path: '/', element: <Home /> },
  { path: '/etica', element: <Etica /> },
  { path: '/transparencia', element: <Transparencia /> },
  { path: '/about', element: <About /> },
  { path: '/fornecedor', element: <Fornecedor /> },
  { path: '/denuncia', element: <Denuncia /> },
  { path: '/servicos', element: <Servicos /> },
  { path: '/contato', element: <Contact /> },
  { path: '/trabalheconosco', element: <TrabalheConosco /> },
  { path: '/login', element: <Login /> },
  { path: '/register', element: <Register /> },
  { path: '/ativar-conta', element: <AtivarConta /> },
  { path: '/recuperar-senha', element: <RecuperarSenha /> },
  { path: '/trocar-senha', element: <TrocarSenha /> },
  { path: '*', element: <NotFound /> },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
